module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "p navigation"
  }, [_vm._l((_vm.menus), function(route) {
    return _c('li', {
      key: route.link,
      class: [
        "navigation__item",
        ("navigation__item--" + (route.link)),
        {
          'navigation__item--active': route.link === _vm.$route.name,
        } ]
    }, [_c('module-link', {
      staticClass: "navigation__link link",
      attrs: {
        "link": route.link,
        "no-underline": true
      }
    }, [_c('b', {
      staticClass: "navigation__marker"
    }), _vm._v(" "), _c('span', {
      staticClass: "navigation__label"
    }, [_vm._v(_vm._s(route.name))])])], 1)
  }), _vm._v(" "), _c('module-button', {
    attrs: {
      "link": "contact",
      "button": "tertiary",
      "level": "tertiary"
    }
  }, [_vm._v("\n    Say hi\n  ")])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64bf3e8b"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/ui/Navigation.vue
// module id = 30
// module chunks = 1